import NavigableValidation from "./navigableValidation";
import FieldPresenceValidator from "~/models/navigableValidators/fieldPresenceValidator";
import {TValidator} from "~/interfaces/validationInterfaces";
import {INavigableValidatorOptions} from "~/models/navigableValidators/navigableValidator";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";
import ProcessFlowVariable from "~/models/processFlows/processFlowVariable";

export default class ProcessFlowVariableValidation<T extends ProcessFlowVariable> extends NavigableValidation<ProcessFlowVariable> {
  validators = [
    ...Object.keys(this.presenceValidatableFields).map<TValidator<string>>(fieldKey => {
      return new FieldPresenceValidator({
        validatorKey: fieldKey,
        section: ValidationModalSection.ProcessFlowVariable,
        ...Object.assign({}, this.presenceValidatableFields[fieldKey])
      })
    })
  ]

  // Validators Options
  get presenceValidatableFields(): { [key in keyof T]?: Partial<INavigableValidatorOptions<T>> } {
    return {
      name: {},
      is_single: {},
      variable_type: {},
      reference_id: {
        conditionalField: 'referenceRequired',
        conditionalValue: true,
      },
      reference_scope_id: {
        conditionalField: 'referenceScopeRequired',
        conditionalValue: true,
      },
      is_input: {},
      is_input_required: {
        conditionalField: "is_input",
        conditionalValue: true,
      },
      is_output: {},
      apiMessageType: {
        conditionalField: "isApi",
        conditionalValue: true,
      }
    }
  }
}